/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportDto } from '../../models/import-dto';

export interface GetImport$Params {
  id: string;
}

export function getImport(http: HttpClient, rootUrl: string, params: GetImport$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportDto>> {
  const rb = new RequestBuilder(rootUrl, getImport.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportDto>;
    })
  );
}

getImport.PATH = '/v0/supervisely/{id}';
